<div class="relative h-full w-full">
  @if (path) {
    <button
      mat-icon-button
      type="button"
      class="!absolute top-3 right-3 z-10"
      [matTooltip]="'Scarica' | siaTranslate"
      [attr.aria-label]="'Scarica' | siaTranslate"
      (click)="download()"
    >
      <mat-icon>download</mat-icon>
    </button>
  }
  <sia-pdf-viewer [file]="documentBase64"></sia-pdf-viewer>
</div>
